// Instância Axios dedicada à API externa de Protocolo Online.
// Cada requisição recebe automaticamente o header Authorization: Bearer {token},
// lido do localStorage, e desloga o usuário se o token expirar/for inválido.
// Também envia x-api-key, exigido pela API de Protocolo para autenticar o portal.

import axios from 'axios';

const protocoloApi = axios.create({
  baseURL: process.env.REACT_APP_PROTOCOLO_API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': process.env.REACT_APP_PROTOCOLO_API_KEY
  }
});

protocoloApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

protocoloApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && window.location.pathname !== '/login') {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default protocoloApi;
